module.exports = __webpack_public_path__ + "img/title3.6a29bdca.webp";